import { Utils } from "@/plugins/utils"
import router from "@/router"
import axios from "axios"
import Enums from "../../plugins/Enums"
import moment from "moment"
import { runtimeConfig } from '@/config/runtimeConfig'
export default {
	namespaced: true,
	state: {
		form: {
			loading: false,
			dc4usuario: "",
			dc4senha: "",
			pd0codigo: "",
			error: "",
		},
		formChangePass: {
			loading: false,
			dc4usuario: "",
			oldDc4senha2: "",
			dc4senha2: "",
			dc4confsen: "",
			error: "",
		},
		dc4tentativas: null,
		dc4bloq: false,
		users: [],
		companies: [],
		lstConfiguredCompanies: [],
		selectedCompany: null,
		terminals: [],
		userLogged: false,
		pd0: null,
		dc4: null,
		lxlexppass: null,
		changePassword: false,
		showChangePassSucess: false,
		loadingUsers: false,
		loadingCompanies: false,
		loadingTerminals: false,
		lstDc4: [],
		lstEst: [],
		lstSelectedEstablishments: [],
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getLstDc4: state => state.lstDc4,
		getLstSelectedEstablishments: state => state.lstSelectedEstablishments,
		getLoading: state => state.loading,
		getItemsPerPage: state => state.itemsPerPage,
		getLxlexppass: state => state.lxlexppass,
		getSearch: state => state.search,
		getHasNext: state => state.hasNext,
		getDc4: state => state.dc4,
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getFormDc4usuario: state => state.form.dc4usuario,
		getForm: state => {
			state.form.dc4troca = state.form.dc4troca ? state.form.dc4troca : false
			state.form.dc4inativo = state.form.dc4inativo ? state.form.dc4inativo : false
			state.form.dc4acext = state.form.dc4acext ? state.form.dc4acext : false
			state.form.lstLgn = state.lstSelectedEstablishments.map(est => {
				return {
					lgnest: est.estid,
					lgnusuario: state.form.dc4usuario
				}
			})
			return state.form
		},
		changePassModel(state) {
			return {
				dc4usuario: state.formChangePass.dc4usuario,
				dc4senha2: state.formChangePass.dc4senha2,
				oldDc4senha2: state.formChangePass.oldDc4senha2
			}
		},
		dc4(state) {
			return {
				dc4usuario: state.form.dc4usuario,
				dc4senha2: state.form.dc4senha2,
				pd0codigo: state.form.pd0codigo,
				module: Enums.OryxModulesType.ORYX_PV,
				company: state.selectedCompany ? state.selectedCompany.companyCode : localStorage.getItem("companyCode"),
				companyName: state.selectedCompany ? state.selectedCompany.companyName : null,
				fingerprint: state.form.fingerprint || null
			}
		},
	},
	mutations: {
		setSearch: (state, search) => (state.search = search),
		setLoading: (state, loading) => (state.loading = loading),
		setLstDc4: (state, lstDc4) => (state.lstDc4 = lstDc4),
		setLstEst: (state, lstEst) => (state.lstEst = lstEst),
		setDc4: (state, dc4) => (state.dc4 = dc4),
		setLxl: (state, lxl) => (state.lxl = lxl),
		setUpdate: (state, update) => (state.update = update),
		setInsert: (state, insert) => (state.insert = insert),
		setDc4senha2: (state, dc4senha2) => (state.form.dc4senha2 = dc4senha2),
		setFormError: (state, error) => (state.form.error = error),
		setFormLstDc5: (state, lstDc5) => (state.form.lstDc5 = lstDc5),
		setLstCf3: (state, lstCf3) => (state.dc4.lstCf3 = lstCf3),
		setLstSelectedEstablishments: (state, lstSelectedEstablishments) => (state.lstSelectedEstablishments = lstSelectedEstablishments),
		setForm(state, dc4) {
			dc4.dc4senha2 = ""
			state.lstSelectedEstablishments = dc4.lstLgn.map(lgn => {
				return {
					estid: lgn.lgnest,
					estnome: state.lstEst.find(el => el.estid ==  lgn.lgnest).estnome
				}
			})
			state.form = dc4
		},
		setUserTries(state, num){
			state.dc4tentativas = num
		},
		blockedUserPayload(state, num) {
			state.dc4bloq = num
		},
		auth(state, oryxAuthenticatedModel) {
			state.pd0 = oryxAuthenticatedModel.pd0
			state.dc4 = oryxAuthenticatedModel.dc4
			state.userLogged = true
		},
		logoff(state) {
			state.userLogged = false
			state.dc4 = null
			localStorage.removeItem("token")
			localStorage.removeItem("company")
			localStorage.removeItem("companyCode")
		},
		initForm(state) {
			state.form = {
				loading: false,
				dc4usuario: "",
				dc4senha: "",
				pd0codigo: "",
				error: "",
				lstLgn: [],
				fingerprint: ""
			}
			state.insert = false
			state.update = false
			state.companies = []
		},
		set(state, dc4) {
			state.dc4 = dc4
			if (dc4) state.update = true
		},
		setParamsDataTable(state, payload) {
			state.lstDc4 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setFormChangePassDc4usuario(state, dc4usuario) {
			state.formChangePass.dc4usuario = dc4usuario
		},
	},
	actions: {
		setSearch: ({ commit }, search) => commit("setSearch", search),
		setLoading: ({ commit }, loading) => commit("setLoading", loading),
		setLstDc4: ({ commit }, lstDc4) => commit("setLstDc4", lstDc4),
		setLstEst: ({ commit }, lstEst) => commit("setLstEst", lstEst),
		setDc4: ({ commit }, dc4) => commit("setDc4", dc4),
		setForm: ({ commit }, dc4) => commit("setForm", dc4),
		setUpdate: ({ commit }, update) => commit("setUpdate", update),
		setInsert: ({ commit }, insert) => commit("setInsert", insert),
		setFormLstDc5: ({ commit }, lstDc5) => commit("setFormLstDc5", lstDc5),
		setDc4senha2: ({ commit }, dc4senha2) => commit("setDc4senha2", dc4senha2),
		setFormError: ({ commit }, error) => commit("setFormError", error),
		setFormChangePassDc4usuario: ({ commit }, dc4usuario) => commit("setFormChangePassDc4usuario", dc4usuario),
		async auth({ commit, dispatch, getters, rootGetters, state }) {
			commit("setLoading", true)
			commit("setFormError", "")
			
			localStorage.removeItem("token")

			try {
				const fingerprint = await this._vm.$fingerprint.getVisitorId();
				state.form.fingerprint = fingerprint;
			} catch (error) {
				state.form.fingerprint = 'unknown';
			}
			
			let payload = await axios
				.post(runtimeConfig.apiUri + "/Authentication/Authentication/Auth", getters.dc4, {
					headers: { "Content-Type": "application/json" },
				})
				.then(async(response) => {
					let oryxAuthenticatedModel = Utils.ValidateAxiosResponse(response.data)
					if(!oryxAuthenticatedModel.isLogged) {
						if (oryxAuthenticatedModel.dc4.dc4troca || (moment(oryxAuthenticatedModel.dc4.dc4dataexp).isBefore(moment(), "day") && getters.getLxlexppass)) {
							router.push(`/oryx/mudar-senha/${oryxAuthenticatedModel.dc4.dc4usuario}/${true}`)
							return false
						}
						this._vm.$axios.defaults.headers.common["Authorization"] = "Bearer ".concat(oryxAuthenticatedModel.token)
						this._vm.$tefAxios.defaults.headers.common["Authorization"] = "Bearer ".concat(oryxAuthenticatedModel.token)
						localStorage.setItem("token", oryxAuthenticatedModel.token)
						localStorage.setItem("company", getters.dc4.company + " - " + getters.dc4.companyName)
						localStorage.setItem("companyCode", getters.dc4.company)
						localStorage.setItem("lastInteraction", new Date().toISOString())
						commit("auth", oryxAuthenticatedModel)
						localStorage.setItem(
							"terminal",
							JSON.stringify({
								pd0codigo: oryxAuthenticatedModel.pd0.pd0codigo,
								lstVd1: [],
							}),
						)
						let lxd = rootGetters['lxd/getLxd']
						if(!lxd){
							await dispatch("lxd/find", {}, { root: true })
							lxd = rootGetters['lxd/getLxd']
						}
						switch(lxd.lxdmodulo) {
							case Enums.OryxModulesType.ORYX_PLACE:
								router.push("/oryxpdv")
								break;
							default:
								router.push("/oryxpdv/caixa")
						}
						commit("setDc4senha2", "")
					}
					return oryxAuthenticatedModel
				})
				.catch(error => {
					if(localStorage.getItem("token")) 
						dispatch("logoff")
					commit("setFormError", error.message)
				})
			commit("setLoading", false)
			return payload
		},
		async logoff(store) {
			await axios
			.put(
					runtimeConfig.apiUri + "/Authentication/Authentication/Logoff",
					{ token: localStorage.getItem("token") },
					{ headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } },
				)
			store.commit("logoff")
			store.commit("initForm")
			router.push("/oryx/login")
			store.dispatch("vd1/clearCart", null, { root: true })
			store.dispatch("vdk/initForm", null, { root: true })
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			store.commit("lxd/resetLxd", null, { root: true })
		},
		async changePass(store) {
			store.state.formChangePass.loading = true
			await axios
				.put(runtimeConfig.apiUri + "/Authentication/Authentication/ChangePass", store.getters.changePassModel)
				.then(response => {
					store.state.formChangePass.dc4senha2 = ""
					store.state.formChangePass.oldDc4senha2 = ""
					store.state.formChangePass.dc4confsen = ""
					store.state.formChangePass.error = ""
					let isUpdate = Utils.ValidateAxiosResponse(response.data)
					if (isUpdate) {
						store.state.showChangePassSucess = true
						router.push("/oryx/login")
						return
					}
					throw new Error("Não foi possível alterar a sua senha.")
				})
				.catch(error => {
					store.state.formChangePass.error = error.message
				})
			store.state.formChangePass.loading = false
		},
		async findAllUsers(store, isFromLogin = false) {
			store.state.loadingUsers = true
			await axios
				.get(runtimeConfig.apiUri + `/Authentication/Authentication/FindAll?isFromLogin=${isFromLogin}`, {
					headers: { "Content-Type": "application/json", "company": store.getters.dc4.company },
				})
				.then(response => {
					store.state.users = Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.state.users = []
					store.state.form.error = error.message
				})
			store.state.loadingUsers = false
		},
		async findAllConnectionsByUser(store, dc4usuario) {
			store.state.loadingCompanies = true
			await axios
				.get(runtimeConfig.apiUri + `/Authentication/Authentication/FindAllConnectionsByUser/${dc4usuario}`, {
					headers: { "Content-Type": "application/json" },
				})
				.then(response => {
					store.state.companies = Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.state.companies = []
					store.state.form.error = error.message
				})
			store.state.loadingCompanies = false
		},
		async findAllEstablishmentByUser(store, dc4usuario) {
			store.state.loadingCompanies = true
			await axios
				.get(runtimeConfig.apiUri + `/Authentication/Authentication/FindAllEstablishmentByUser/${dc4usuario}`, {
					headers: { "Content-Type": "application/json" },
				})
				.then(response => {
					store.state.lstSelectedEstablishments = Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.state.lstSelectedEstablishments = []
					store.state.form.error = error.message
				})
			store.state.loadingCompanies = false
		},
		async findAllEstablishment({commit, dispatch}){
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.get(`/Authentication/Authentication/FindAllEstablishment`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setLstEst", payload)
					return true
				})
				.catch(error => {
					commit("setLstEst", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		addEstablishment(store, est) {
			let lstSelectedEstablishments = store.state.lstSelectedEstablishments ?? [];
			lstSelectedEstablishments.push(est);
			store.commit("setLstSelectedEstablishments", lstSelectedEstablishments);
		},
		removeEstablishment(store, lstSelectedEstablishments) {
			store.commit("setLstSelectedEstablishments", lstSelectedEstablishments);
		},
		async getUserData({ state, getters }, dc4usuario) {
			try {
				const response = await axios.get(
					`${runtimeConfig.apiUri}/Authentication/Authentication/GetUserData/${dc4usuario}`,
					{
						headers: {
							"Content-Type": "application/json",
							company: getters["dc4/company"],
						},
					},
				)
				const payload = Utils.ValidateAxiosResponse(response.data)
				return payload
			} catch (error) {
				state.form.error = error.message
			}
		},
		async findBlockedUser({ commit, state, getters }, dc4usuario) {
			try {
				const response = await axios.get(
					`${runtimeConfig.apiUri}/Authentication/Authentication/FindBlockedUser/${dc4usuario}`,
					{
						headers: {
							"Content-Type": "application/json",
							company: getters["dc4/company"],
						},
					},
				)
				const payload = Utils.ValidateAxiosResponse(response.data)
				commit("blockedUserPayload", payload)
				return payload
			} catch (error) {
				state.form.error = error.message
			}
		},
		async incrementNumberOfTries({ commit, state, getters }, dc4usuario) {
			try {
				const response = await axios.put(
					`${runtimeConfig.apiUri}/Authentication/Authentication/IncrementNumberOfTries/${dc4usuario}`,
					null,
					{
						headers: {
							"Content-Type": "application/json",
							company: getters["dc4/company"],
						},
					}
				);
				const payload = Utils.ValidateAxiosResponse(response.data);
				commit("setUserTries", payload);
			} catch (error) {
				state.form.error = error.message
			}
		},
		async findAllTerminals(store) {
			store.state.loadingTerminals = true
			await axios
				.get(runtimeConfig.apiUri + "/OryxPdv/Terminal/FindList", {
					headers: { "Content-Type": "application/json", "company": store.getters.dc4.company  },
				})
				.then(response => {
					store.state.terminals = Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.state.terminals = []
					store.state.form.error = error.message
				})
			store.state.loadingTerminals = false
		},
		async verifyUser(store) {
			let token = localStorage.getItem("token")
			if (token) {
				this._vm.$axios.defaults.headers.common["Authorization"] = "Bearer ".concat(token)
				this._vm.$tefAxios.defaults.headers.common["Authorization"] = "Bearer ".concat(token)
			}
			return await this._vm.$axios
				.post("/Authentication/Authentication/Authenticated")
				.then(response => {
					let dc4 = Utils.ValidateAxiosResponse(response.data)
					store.state.dc4 = dc4
					store.state.userLogged = true
					return true
				})
				.catch(error => {
					if(localStorage.getItem("token")) 
						store.dispatch("logoff")
					return false
				})
		},
		async verifyTerminal(store) {
			let pd0codigo = ""
			let terminal = localStorage.getItem("terminal")
			if (terminal) {
				pd0codigo = JSON.parse(terminal).pd0codigo
			}

			await this._vm.$axios
				.get("/OryxPdv/Terminal/Reload/" + pd0codigo)
				.then(response => {
					let pd0 = Utils.ValidateAxiosResponse(response.data)
					store.state.pd0 = pd0
					store.state.form.pd0codigo = pd0.pd0codigo
				})
				.catch(error => {
					store.state.pd0 = null
					store.state.form.pd0codigo = ""
				})
		},
		async verifyPass(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Validando acesso", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post("/Authentication/Authentication/VerifyPass", store.getters.dc4)
				.then(response => {
					store.state.form.dc4senha = ""
					let oryxAuthenticatedModel = Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					store.commit("setFormError", error.message)
					return false
				})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async validateUserLogin(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Validando acesso", indeterminate: true },
				{ root: true },
			)
			store.state.form.loading = true

			let payload = await axios
				.post(runtimeConfig.apiUri + "/Authentication/Authentication/ValidateUserLogin", {dc4usuario: store.state.form.dc4usuario, dc4senha2: store.state.form.dc4senha2 }, {
						headers: { "Content-Type": "application/json" },
					})
				.then(response => {
					const payload = Utils.ValidateAxiosResponse(response.data)
					this._vm.$set(store.state.form, "dc4usuario", payload.dc4usuario)
					return true
				})
				.catch(error => {
					store.commit("setFormError", error.message)
					return false
				})

			store.state.form.loading = false
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async verifyAccess(store, { dc0arquivo, permission = "", verifySupervisor= false }) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Validando acesso", indeterminate: true },
				{ root: true },
			)

			let route = "/Authentication/Authentication/VerifyAccess/" + dc0arquivo
			if (!!permission) {
				route += "/" + permission
			}

			route += "/" + verifySupervisor

			let payload = await this._vm.$axios
				.post(route, store.getters.dc4)
				.then(response => {
					store.state.form.dc4senha = ""
					let oryxAuthenticatedModel = Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					store.commit("setFormError", error.message)
					return false
				})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		revoke(store) {
			let model = {
				token: localStorage.getItem("token"),
				company: localStorage.getItem("companyCode")
			}
			return axios
				.post(
					runtimeConfig.apiUri + "/Authentication/Authentication/Revoke",
					model, 
					{ headers: { "Content-Type": "application/json" } },
				)
				.then(response => {
					let oryxAuthenticatedModel = Utils.ValidateAxiosResponse(response.data)
					this._vm.$axios.defaults.headers.common["Authorization"] = "Bearer ".concat(oryxAuthenticatedModel.token)
					this._vm.$tefAxios.defaults.headers.common["Authorization"] = "Bearer ".concat(oryxAuthenticatedModel.token)
					localStorage.setItem("token", oryxAuthenticatedModel.token)
					store.commit("auth", oryxAuthenticatedModel)
					return oryxAuthenticatedModel.token
				})
				.catch(error => {
					if(localStorage.getItem("token"))
						store.dispatch("logoff")
					return false
				})
		},
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, dc4usuario) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Authentication/Authentication/Find/${dc4usuario}`)
				.then(response => {
					let dc4 = Utils.ValidateAxiosResponse(response.data)
					commit("setForm", dc4)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.post("/Authentication/Authentication/Insert", store.state.form)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/usuarios/")
					store.state.form = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put("/Authentication/Authentication/Update", store.state.form)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/usuarios/")
					store.state.form = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Authentication/Authentication/Delete/${store.state.form.dc4usuario}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/usuarios")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Authentication/Authentication/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstDc4", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async importPermitions({ commit, dispatch, getters }, dc4usuario) {
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.get(`/Authentication/Authentication/FindAllDc5/${dc4usuario}`)
				.then(response => {
					let lstDc5 = Utils.ValidateAxiosResponse(response.data)
					lstDc5.forEach(dc5 => {
						dc5.dc5usuario = getters.getFormDc4usuario
					})
					commit("setFormLstDc5", lstDc5)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async findAllConfiguredCompanies(store) {
			store.state.loadingCompanies = true
			await axios
				.get(runtimeConfig.apiUri + "/Authentication/Authentication/FindAllConfiguredCompanies", {
					headers: { "Content-Type": "application/json" },
				})
				.then(response => {
					store.state.lstConfiguredCompanies = Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.state.lstConfiguredCompanies = []
					store.state.form.error = error.message
				})
			store.state.loadingCompanies = false
		},
		async unlockUser(store, dc4) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Desbloqueando usuário", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put("/Authentication/Authentication/UnlockUser", dc4)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async lockUser(store, dc4usuario) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Bloqueando usuário", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.put(`/Authentication/Authentication/LockUser?dc4usuario=${dc4usuario}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
